// extracted by mini-css-extract-plugin
export default {"labelWithTooltip":"labelWithTooltip--BHqYq"};